module.exports = __webpack_public_path__ + "img/droplet_blue.c3e8bfb1.svg";